import {getInternalClock} from '../../actions/InternalClockAction';

export const SyncTime = (dispatch, server_date) => {
  let device_time_stamp = new Date().getTime();
  let server_time_stamp = new Date(server_date).getTime();
  let difference_time_stamp = server_time_stamp - device_time_stamp;
  dispatch(
    getInternalClock({
      difference_time_stamp: Number(difference_time_stamp),
    }),
  );
};

export default SyncTime;
